/**
 * MobX store for supported Global-e environments on this deployment (GET admin-supported-global-e-envs).
 * Shared across all cards on the migrate Global-e merchants admin page.
 */
import { makeAutoObservable, runInAction } from "mobx";
import AdminMigrateGlobalEMerchantsService, {
    ISupportedGlobalEEnvironment,
} from "../../../../services/api/admin-migrate-global-e-merchants-service";
import { rootContainer, TYPE } from "../../../../services/container/root";
import { IOption } from "../../../../components/inputs/select-dropdown/select-dropdown";

class SupportedGlobalEEnvsStore {
    private _isLoading = false;
    private _isLoaded = false;
    private _environments: ISupportedGlobalEEnvironment[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get service(): AdminMigrateGlobalEMerchantsService {
        return rootContainer.get<AdminMigrateGlobalEMerchantsService>(TYPE.AdminMigrateGlobalEMerchantsService);
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public get isLoaded(): boolean {
        return this._isLoaded;
    }

    public get hasSupportedEnvironments(): boolean {
        return this._environments.length > 0;
    }

    public get environmentOptions(): IOption[] {
        return this._environments.map((env) => ({
            value: env.value,
            label: env.label,
        }));
    }

    public async fetchSupportedEnvironments(): Promise<void> {
        if (this._isLoading || this._isLoaded) {
            return;
        }

        this._isLoading = true;
        try {
            const response = await this.service.fetchSupportedGlobalEEnvironments();
            runInAction(() => {
                this._environments = response.environments ?? [];
            });
        } catch (e) {
            console.error("[SupportedGlobalEEnvsStore::fetchSupportedEnvironments] failed:", e);
            runInAction(() => {
                this._environments = [];
            });
        } finally {
            runInAction(() => {
                this._isLoading = false;
                this._isLoaded = true;
            });
        }
    }
}

export default new SupportedGlobalEEnvsStore();
